
export const orderSummaryDataSaga = (state) => state.ordersPageReducer.orderSummaryRows;

export const orderHistoryDataSaga = (state) => state.ordersPageReducer.orderHistoryRows;
export const orderHistoryDataErrorSaga = (state) => state.ordersPageReducer.orderHistoryRowsError;

export const transactionDetailsSaga = (state) => state.transactionReducer.transactionDetails;

export const orderDownloadSelectionSaga = (state) => state.ordersPageReducer.orderDownloadSelection;
export const orderDownloadDataSaga = (state) => state.ordersPageReducer.orderDownloadData;
export const orderDownloadLoadingSaga = (state) => state.ordersPageReducer.orderDownloadLoading
